import { COUNTRY } from '@/config';

const AGENT_URL = `${window.location.origin}/agente`;

const AGENT_URL_CREATE = {
  br: `${AGENT_URL}/criar`,
  mx: `${AGENT_URL}/crear`,
  es: `${AGENT_URL}/crear`,
};

const AGENT_URL_EDIT = id => ({
  br: `${AGENT_URL}/editar/?id=${id}`,
  mx: `${AGENT_URL}/editar/?id=${id}`,
  es: `${AGENT_URL}/editar/?id=${id}`,
});

export const AGENT_FACTORY_URL_HOME = AGENT_URL;
export const AGENT_FACTORY_URL_CREATE = AGENT_URL_CREATE[COUNTRY];
export const AGENT_FACTORY_URL_EDIT = id => AGENT_URL_EDIT(id)[COUNTRY];

export const VIMEO_AGENT_WELCOME_EMBED_URL = 'https://player.vimeo.com/video/1137855096';
